export const AlertConstants = {
  sendAlertsTo: 'Send Alerts To',
  preventDispatch: 'Prevent Dispatch',
  willPreventDispatch: 'Will Prevent Dispatch',
  frequency: 'Frequency',
};
